import './limit.scss';
import agentPageStore from '@/pages/agent-home/store';
import membershipStore from '@/components/membership/store';
import { observer } from 'mobx-react-lite';

import userStore from '@/store/user';
import client from '@/store/client';
import { HelperCore } from '@/common/dependencies';

const LimitContent = observer(({pos}) => {
  const isSe = client.is360se || (HelperCore.isMac() && client.isLLQ);
  const agentLimit = agentPageStore.chatLimit;
  const is_member = userStore?.membershipInfo?.is_member
  const expire_at = userStore?.membershipInfo?.expire_at || 0;
  const coinBalance = userStore?.coinBalance
  const membershipUsage = userStore?.membershipUsage?.find((item) => item?.function_id === 'agent_count_limit')
  const all_left = membershipUsage?.free_remaining + membershipUsage?.gift_remaining + membershipUsage?.count_remaining
  // free_period 每日 daily
  const periodTextMap = {
    daily: '每日',
    weekly: '每周',
    monthly: '每月',
    quarterly: '每季度',
    yearly: '每年',
    never: '总计',
  };
  const free_period = membershipUsage?.free_period || 'never';
  const free_count = membershipUsage?.free_count || 0;
  const price = membershipUsage?.price || 300;
  const usage_limit = membershipUsage?.usage_limit || 100;

  const posMapLog = {
    aiso: {
        position:'page_ai_search',
        feature: '',
    },
    aiagent: {
        position:'page_intelligent_agent',
        feature: 'card',
    },
    aisquare: {
        position:'page_supersearch',
        feature: 'card',
    },
  }

  const vipBtn = () => (
    isSe ? null : <div className="relative">
      <div
        className="cursor-pointer relative w-full h-44px text-[#272979] leading-44px text-center text-16px font-medium limit-content-btn flex flex-col justify-center"
        style={{
          borderRadius: '30px',
          background: 'linear-gradient(270deg, #FFBEF5 0%, #D1EDFD 100%)',
          boxShadow:
            '0px 0px 20px 4px rgba(255, 255, 255, 0.25) inset, 0px 0px 20px 3px #FFF inset',
        }}
        onClick={() => {
          membershipStore.setData({
            show: true,
            checkstandType: "openMembership",
            position:posMapLog[pos]?.position || '',
            feature: posMapLog[pos]?.feature || '',
          })
        }}
      >
        <div className='inline-block w-full text-16px font-medium'>{is_member ? '续费会员' : '开通会员'}</div>
        {is_member && expire_at > 0 && <div className='inline-block w-full text-10px opacity-50 leading-normal'>{HelperCore.longTimeSpecial(expire_at, 'YYYY-MM-DD')}到期</div>}
      </div>
      <div className="text-12px font-normal leading-normal text-white bg-[#FF587F] absolute right-[0px] top-[-13px] py-3px px-8px rounded-[3.85px] rounded-tl-[10.6px] rounded-br-[10.6px]">
        送纳米
      </div>
      <div className="absolute top-[-34px] left-[7px] z-100 pointer-events-none">
        <img src="https://p1.ssl.qhimg.com/t110b9a9301fe3d916c6e4e4c24.png" alt="" srcset="" width={72} height={72}/>
      </div>
    </div>
  );

  const namiBtn = ({ style }) => (
    isSe ? null : <div className="relative">
      <div
        className="cursor-pointer relative w-full h-44px text-[#272979] leading-44px text-center text-16px font-medium limit-content-btn flex flex-col justify-center"
        style={{
          borderRadius: '30px',
          background: 'linear-gradient(270deg, #FFBEF5 0%, #D1EDFD 100%)',
          boxShadow:
            '0px 0px 20px 4px rgba(255, 255, 255, 0.25) inset, 0px 0px 20px 3px #FFF inset',
          ...style,
        }}
        onClick={() => {
            membershipStore.setData({
              show: true,
              checkstandType: "namidou",
              position: posMapLog[pos]?.position || '',
              feature: posMapLog[pos]?.feature || '',
            })
        }}
      >
        <div className='inline-block w-full text-16px font-medium'>充值纳米</div>
        <div className='inline-block w-full text-10px leading-10px mt-2px opacity-50 leading-normal bg-gradient-to-r from-[#D1EDFD] to-[#FFBEF5] bg-clip-text text-transparent'>（纳米余额：{coinBalance?.balance}）</div>
      </div>
    </div>
  );
  return (
    <div className="w-full h-full text-left">
      <div className="text-16px font-normal leading-normal mb-12px">
        {isSe ? '' : 'VIP'} 限免超级智能体/深度研究规则
      </div>
      <div className={`w-full ${isSe ? 'h-38px':'h-68px'} text-14px font-normal leading-normal flex flex-col justify-between mb-22px`}>
        <div className="flex flex-nowrap justify-between">
          <span className="opacity-70">剩余免费次数（{periodTextMap[free_period]}赠送 {free_count || 0} 次）:</span>
          <span className="font-medium bg-gradient-to-r from-[#E6F5FC] via-[#CEF0FF] to-[#FDCFEE] bg-clip-text text-transparent">
            {/* {(agentLimit.daily_left || 0) + (agentLimit.invite_left || 0)}次 */}
            {(membershipUsage?.remaining - (membershipUsage?.gift_remaining || 0)) || 0}次
          </span>
        </div>
        <div className="flex flex-nowrap justify-between">
          <span className="opacity-70">邀请好友额外获得：</span>
          <span className="font-medium bg-gradient-to-r from-[#E6F5FC] via-[#CEF0FF] to-[#FDCFEE] bg-clip-text text-transparent">
            {membershipUsage?.gift_remaining || 0}次
          </span>
        </div>
        {isSe ? null : <div className="flex flex-nowrap justify-between">
          <span className="opacity-70">限时特惠：</span>
          <span className="font-medium bg-gradient-to-r from-[#E6F5FC] via-[#CEF0FF] to-[#FDCFEE] bg-clip-text text-transparent">
            {usage_limit}（<span className="line-through text-[#E6F5FC]">{price}</span>）纳米/次
          </span>
        </div>}
      </div>
      <div className="relative flex gap-10px mb-10px" style={{
        marginBottom: isSe ? '5px': ''
      }}>
        <button className="w-170px">
          {namiBtn({
            style: {
              background: 'rgba(37, 53, 115, 1)',
              color: 'white',
              boxShadow: 'none',
            },
          })}
        </button>
        <div className="w-170px">{vipBtn()}</div>
      </div>
      <div className="text-10px opacity-50 font-normal leading-normal">
        将优先为您扣除时效性短的次数
      </div>
    </div>
  );
});

export default LimitContent;
